import { useCallback, useMemo, useState } from 'react';

import { FirmwareUpdateStatus, FirmwareUpdateStatusEvent } from '../types';
import { useDeviceStatusSocket } from './useDeviceStatusSocket';

export function useFirmwareUpdateStatus(deviceId: string) {
  const [status, setStatus] = useState<FirmwareUpdateStatusEvent | null>(null);

  const handleFirmwareUpdateStatus = useCallback(
    (event: FirmwareUpdateStatusEvent) => {
      if (event.deviceId === deviceId) {
        setStatus(event);
      }
    },
    [deviceId],
  );

  useDeviceStatusSocket(
    {
      onFirmwareUpdateStatus: handleFirmwareUpdateStatus,
    },
    useMemo(() => [deviceId], [deviceId]),
  );

  const clearStatus = useCallback(() => {
    setStatus(null);
  }, []);

  return {
    status,
    clearStatus,
    isInProgress:
      status?.status === FirmwareUpdateStatus.DOWNLOADING_STARTED ||
      status?.status === FirmwareUpdateStatus.DOWNLOADING_FINISHED ||
      status?.status === FirmwareUpdateStatus.STARTED,
    isError:
      status?.status === FirmwareUpdateStatus.DOWNLOADING_FAILED ||
      status?.status === FirmwareUpdateStatus.FAILED,
    isSuccess: status?.status === FirmwareUpdateStatus.FINISHED,
  };
}
